import { render, staticRenderFns } from "./validScene.vue?vue&type=template&id=0bc48906&scoped=true&"
import script from "./validScene.vue?vue&type=script&lang=js&"
export * from "./validScene.vue?vue&type=script&lang=js&"
import style0 from "./validScene.vue?vue&type=style&index=0&id=0bc48906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc48906",
  null
  
)

export default component.exports